import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./hero.css";

/* DESKTOP IMAGES */
import img1 from "../../Assets/Hero/Hero1.webp";
import img2 from "../../Assets/Hero/Hero2.webp";
import img3 from "../../Assets/Hero/Hero3.webp";

/* MOBILE IMAGES */
import mobImg1 from "../../Assets/Hero/HeroMob1.webp";
import mobImg2 from "../../Assets/Hero/HeroMob2.webp";
import mobImg3 from "../../Assets/Hero/HeroMob3.webp";

/* SLIDES */
const desktopSlides = [
  {
    id: 1,
    title: (
      <h1>
        Driving Excellence <br /> in Automobile <br /> Logistics
      </h1>
    ),
    image: img1,
  },
  {
    id: 2,
    title: (
      <h1>
        Powering Reliable Vehicle <br />
        Transportation <br /> Across India
      </h1>
    ),
    image: img2,
  },
  {
    id: 3,
    title: (
      <h1>
        Trusted Partners in <br />
        Pan-India Automobile <br /> Logistics
      </h1>
    ),
    image: img3,
  },
];

const mobileSlides = [
  { id: 1, title: desktopSlides[0].title, image: mobImg1 },
  { id: 2, title: desktopSlides[1].title, image: mobImg2 },
  { id: 3, title: desktopSlides[2].title, image: mobImg3 },
];

const Hero = () => {
  const [index, setIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  /* Detect screen */
  useEffect(() => {
    const resize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);

  /* Auto slide */
  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % desktopSlides.length);
    }, 3000);
    return () => clearInterval(timer);
  }, []);

  const slides = isMobile ? mobileSlides : desktopSlides;

  /* ANIMATIONS */
  const desktopPanelVariants = {
    initial: { y: "100%" },
    animate: { y: "0%" },
    exit: { opacity: 0 },
  };

  const mobileFadeVariants = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
  };

  return (
    <div className="hero-split-container">
      <AnimatePresence mode="wait">
        <motion.div key={index} className="slide-wrapper">

          {/* BACKGROUND */}
          <div className="split-background">
            {isMobile ? (
              <motion.div
                className="split-panel mobile-only"
                variants={mobileFadeVariants}
                initial="initial"
                animate="animate"
                exit="exit"
                transition={{ duration: 1 }}
                style={{ backgroundImage: `url(${slides[index].image})` }}
              />
            ) : (
              [0, 1, 2].map((panelIndex) => (
                <motion.div
                  key={panelIndex}
                  className="split-panel"
                  variants={desktopPanelVariants}
                  initial="initial"
                  animate="animate"
                  exit="exit"
                  transition={{
                    duration: 1.2,
                    ease: "cubic-bezier(0.6, 0.01, -0.05, 0.95)",
                    delay: panelIndex * 0.12,
                  }}
                  style={{
                    backgroundImage: `url(${slides[index].image})`,
                    backgroundPosition: `${panelIndex * 50}% center`,
                  }}
                />
              ))
            )}
          </div>

          {/* TEXT OVERLAY */}
          <div className="hero-overlay">
            <motion.div
              className="hero-main-content"
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.6, duration: 0.8 }}
            >
              {slides[index].title}
            </motion.div>
          </div>

        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default Hero;
